import { createFileRoute } from "@tanstack/react-router";

import { SettingsMembers } from "@/features/my/settings/household/members";

export const Route = createFileRoute(
  "/(member)/(protected)/my/settings/household/members",
)({
  component: SettingsMembers,
});
